module.exports = __webpack_public_path__ + "static/c98945d7ee741300af19918f8674bda1d342b043beaf37f30b3880028bdd1044-078aac906a36344888d562690b61eb6e.png";